'use client';

import { HyperLink as MarketistHyperLink, type HyperLinkProps } from '@doist/marketist';
import cn from 'clsx';
import css from './hyper-link.module.css';
export function HyperLink({
  className,
  ...rest
}: HyperLinkProps) {
  return <MarketistHyperLink className={cn(css.hyperLink, className)} {...rest} data-sentry-element="MarketistHyperLink" data-sentry-component="HyperLink" data-sentry-source-file="hyper-link.tsx" />;
}